import { saveAs } from "file-saver";
import { DownloadIcon } from "lucide-react";

import { Column, FileViewer, Row } from "@/components";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";

import { useGetJobFile } from "@/hooks/queries/useGetJobFile";

const JobFileViewer = ({ jobFileId }: { jobFileId: number }) => {
  const {
    data: jobFile,
    refetch,
    status,
  } = useGetJobFile({
    enabled: true,
    jobFileId,
  });

  if (status === "pending") {
    // TODO: Loading state.
    return null;
  }

  if (status === "error") {
    // TODO: Error state.
    return null;
  }

  return (
    <Column className="gap-4">
      <Row className="items-center justify-between">
        <p className="text-lg font-semibold text-slate-700">{jobFile.name}</p>
        <Button
          className="rounded-full"
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onClick={async (e) => {
            e.stopPropagation();
            const { data } = await refetch();
            if (!data) return;
            saveAs(data.signedUrl, data.name);
          }}
          variant="outline"
        >
          <DownloadIcon className="h-4 w-4" />
          Download
        </Button>
      </Row>
      <FileViewer mimeType={jobFile.mimeType} url={jobFile.signedUrl} />
    </Column>
  );
};

export const JobFileViewerDialog = ({
  jobFileId,
  onOpenChange,
  open,
}: {
  jobFileId?: number;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}) => {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="max-h-[92vh] overflow-y-scroll">
        {/* This ensures spacing between top of dialog and content. */}
        <DialogHeader />
        {/* The dialog should only be open when `jobFileId` is present. */}
        {jobFileId && <JobFileViewer jobFileId={jobFileId} />}
      </DialogContent>
    </Dialog>
  );
};
